<template>
    <div>
        <audio style="{display: none}" :src="url" ref="audio" autoplay></audio>
    </div>
</template>

<script>
export default {
    name: 'ShAudio',
    props: {
        url: {
            type: String,
            default: ''
        },
    },
    data () {
        return {

        }
    },
    computed: {

    },
    methods: {

    },
    created () {

    },
    mounted () {
        // this.$refs.audio.play().then((e) => {
        //     console.log(e)
        // }).catch((err) => {
        //     console.log(err)
        // })
        const _this = this

        const audio = document.getElementsByTagName('audio')[0];
        audio.addEventListener('play', function () {
            console.log('音频开始播放')
            _this.$emit('play')
        });
        audio.addEventListener('ended', function () {
            console.log('音频播放结束')
            _this.$emit('ended', '播放结束')
        });
    },
    beforeDestroy () {
        
    },
    watch: {

    }
}
</script>

<style lang="scss" scoped>

</style>
